import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __EVENT_ADMIN_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { PecComunicazioneVO } from 'shell/models/pec';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonPecCrumbs } from '../constants';
import { transformPec } from 'shell/components/shared/management-pec/pec-details/utils/transformer-pec';
import FormPec, { PecForm } from 'shell/components/shared/management-pec/pec-details/form';

const PecDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [pec, getPec] = useHttpFetch<HttpResponse<PecComunicazioneVO>, PecForm>(
    `${__EVENT_ADMIN_API_URL__}/pec/comunicazione/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformPec,
    }
  );

  const navigate = useNavigate();

  const loadingPec = pec.isLoading || pec.pristine || pec.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonPecCrumbs,
          {
            name: 'Dettaglio PEC',
          },
        ]}
      />
      {loadingPec ? null : (
        <FormPec
          title={`PEC - ${params.id}`}
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/pec');
          }}
          getPecDetail={getPec}
          idDetail
          initialValues={pec.data as PecForm}
        />
      )}
    </Fragment>
  );
};

PecDetailPage.displayName = 'Pec Detail page component';

export default PecDetailPage;
